import { render, staticRenderFns } from "./dark-topbar.vue?vue&type=template&id=8db67608"
import script from "./dark-topbar.vue?vue&type=script&lang=js"
export * from "./dark-topbar.vue?vue&type=script&lang=js"
import style0 from "./dark-topbar.vue?vue&type=style&index=0&id=8db67608&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports